/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
function e(e){return"usedMemory"in e&&"unloadedMemory"in e&&"ignoresMemoryFactor"in e}export{e as isMemoryManagedView};
